import { Button, Tooltip } from "@mui/material"
import DeleteIcon from '@mui/icons-material/Delete';
import { COLORS } from "../../theme/theme-options";

export const DeleteButton: React.FC<{
    onClick: () => void;
    disabled?: boolean;
    disabledReason?: string;
}> = ({ onClick, disabled, disabledReason }) => {
    const button = <Button disabled={disabled} onClick={onClick} startIcon={<DeleteIcon />} sx={{
        borderColor: COLORS.error[700], 
        color: COLORS.error[700],
        ":hover": {
            borderColor: COLORS.error[700], 
            boxShadow: "0 0 1px rgba(36,41,49,.1),0 1px 2px rgba(36,41,49,.5)",
            backgroundColor: "transparent",
        }
    }} variant="outlined">Delete</Button>;

    if (disabled && disabledReason) {
        return (
            <Tooltip title={disabledReason} placement="top" arrow>
                <span>{button}</span>
            </Tooltip>
        );
    }

    return button;
}
